import { createFeatureSelector, createSelector } from '@ngrx/store';

import { containerFeatureKey, ContainerState } from 'app/state/containers/container.reducer';

export const selectContainerState = createFeatureSelector<ContainerState>(containerFeatureKey);

export const selectContainerList = createSelector(selectContainerState, (state) => state.containerList);

export const selectContainerByNumber = (containerNumber: number) =>
    createSelector(selectContainerList, (containerList) =>
        containerList.find((c) => c.number === containerNumber),
    );

export const selectContainerListbyNumbers = (containerNumbers: number[]) => {
    return createSelector(selectContainerList, (containerList) =>
        containerNumbers.map((containerNumber) => {
            return containerList.find((con) => con?.number === containerNumber)?.name;
        }),
    );
};
